import MUIList, { ListProps } from '@mui/material/List';
import MUIListItem, { ListItemProps } from '@mui/material/ListItem';
import MUIListItemButton, { ListItemButtonProps } from '@mui/material/ListItemButton';
import MUIListItemIcon, { ListItemIconProps } from '@mui/material/ListItemIcon';
import MUIListItemSecondaryAction, { ListItemSecondaryActionProps } from '@mui/material/ListItemSecondaryAction';
import MUIListItemText, { ListItemTextProps } from '@mui/material/ListItemText';
import MUIListSubheader, { ListSubheaderProps } from '@mui/material/ListSubheader';
import MUIMenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import MUIMenuList, { MenuListProps } from '@mui/material/MenuList';
import React from 'react';

interface IListItemTextProps
	extends Pick<
		ListItemTextProps,
		| 'sx'
		| 'style'
		| 'children'
		| 'primary'
		| 'secondary'
		| 'inset'
		| 'primaryTypographyProps'
		| 'secondaryTypographyProps'
		| 'disableTypography'
		| 'onClick'
	> {}

export const List = (props: ListProps) => {
	return <MUIList {...props} />;
};

export const ListItem = (props: ListItemProps) => {
	return <MUIListItem {...props} />;
};

export const ListItemIcon = (props: ListItemIconProps) => {
	return <MUIListItemIcon {...props} />;
};

export const ListItemText = (props: IListItemTextProps) => {
	return <MUIListItemText {...props} />;
};

export const ListItemButton = React.forwardRef<HTMLDivElement, ListItemButtonProps>(function ListItemButton(props, ref) {
	return <MUIListItemButton ref={ref} {...props} />;
});

export const MuiMenuList = (props: MenuListProps) => {
	return <MUIMenuList {...props} />;
};

export function MuiMenuItem(props: MenuItemProps) {
	return <MUIMenuItem {...props} />;
}

export function ListSubheader(props: ListSubheaderProps) {
	return <MUIListSubheader {...props} />;
}

export function ListItemSecondaryAction(props: ListItemSecondaryActionProps) {
	return <MUIListItemSecondaryAction {...props} />;
}
